import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import Toast from "../../../../helper/Toast";
import EditUtilityFormView from "./EditUtilityFormView";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import Utility from "../../../../../model/utility/Utility";
import {updateUtility} from "../../../../../store/action/utility/utility";

interface IComponentProps {
	/**
	 * Close modal callback
	 */
	closeModal: () => void;
	/**
	 * Utility to edit
	 */
	editedUtility: Utility;
}

interface IDispatchProps {
	/**
	 * Update utility.
	 */
	updateUtility: (utilityId: string, data: Utility, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps;

class EditUtilityForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditUtilityFormView onSubmit={this.onSubmit}
								 onCancel={this.props.closeModal}
								 editedUtility={this.props.editedUtility}
								 isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: Utility) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateUtility(
				this.props.editedUtility.id,
				data,
				() => {
					Toast.success("Utility updated", "Utility update");
					this.setState({isSubmitting: false});
					this.props.closeModal();
				},
				(error) => {
					notifyBugsnagAndShowToast(error, "Utility update");
					this.setState({isSubmitting: false});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateUtility: (utilityId: string, data: Utility, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateUtility(utilityId, data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(EditUtilityForm);